// 可以设置尺寸
if (!customElements.get("swiper-slide-show")) {
  class SwiperSlideShow extends HTMLElement {
    /**
     * Section settings
     *
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     *
     * @type {Swiper}
     */
    mySwiper;

    resizeTimeout; // Timeout for resize event
    observer;

    constructor() {
      super();
      this.size = this.classList;
      this.sectionSettings = JSON.parse(
        this.getAttribute("data-settings").replace(/&quot;/g, '"')
      );
      this.pagination = this.querySelector(".swiper-pagination");
      this.onResize = this.onResize.bind(this);
      this.adjustSwiperWidgetBox = this.adjustSwiperWidgetBox.bind(this);
    }

    connectedCallback() {
      this.initializeSwiper();
      this.setInfoHeight();

      requestAnimationFrame(() => {
        this.initSlideProgress();
        this.slideProgress();

        this.observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class"
            ) {
              this.slideProgress();
            }
          });
        });

        this.observer.observe(this.pagination, {
          attributes: true,
          subtree: true,
        });
      });

      this.autoPlayVideo();
      this.mySwiper.on("slideChangeTransitionEnd", () => this.autoPlayVideo());

      const debouncedAutoPlayVideo = this.debounce(() => {
        this.autoPlayVideo();
      }, 200);

      window.addEventListener("scroll", debouncedAutoPlayVideo);
      window.addEventListener("resize", this.onResize);

      this.adjustSwiperWidgetBox();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        console.log("Observer disconnected");
      }
      window.removeEventListener("resize", this.onResize);
    }

    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.reRender();
      }, 200);
    }

    reRender() {
      if (this.mySwiper) {
        this.mySwiper.destroy(true, true);
        this.mySwiper = null;
      }
      this.innerHTML = this.innerHTML;
      this.connectedCallback();
    }

    adjustSwiperWidgetBox() {
      const swiperWidgetBoxes = this.querySelectorAll(".swiper-widget-box");

      if (!swiperWidgetBoxes || swiperWidgetBoxes.length === 0) {
        console.error("No .swiper-widget-box found in the document");
        return;
      }

      swiperWidgetBoxes.forEach((swiperWidgetBox) => {
        if (window.innerWidth >= 1280) {
          const closestTextImageInfoBox = swiperWidgetBox
            .closest(".swiper")
            .querySelector(".swiper-slide-active .text-image-info-box");

          if (closestTextImageInfoBox) {
            const textImageInfoBoxHeight = closestTextImageInfoBox.offsetHeight;
            swiperWidgetBox.style.height = `${textImageInfoBoxHeight}px`;

            const textImageInfoBoxRect =
              closestTextImageInfoBox.getBoundingClientRect();
            const rightDistance =
              document.documentElement.clientWidth - textImageInfoBoxRect.right;

            swiperWidgetBox.style.right = `${rightDistance}px`;
          } else {
            console.error("No .text-image-info-box found in the document");
          }
          swiperWidgetBox.style.top = `0`;
        } else {
          const textImageInfoOuter = swiperWidgetBox
            .closest(".swiper")
            .querySelector(".swiper-slide-active .text-image-info-outer");

          if (textImageInfoOuter) {
            const swiper = swiperWidgetBox.closest(".swiper");
            const textImageInfoOuterRect =
              textImageInfoOuter.getBoundingClientRect();
            const swiperRect = swiper.getBoundingClientRect();
            const topDistance = textImageInfoOuterRect.top - swiperRect.top + 8;

            swiperWidgetBox.style.top = `${topDistance}px`;
          } else {
            console.error("No .text-image-info-outer found in the document");
          }
        }
      });
    }

    initializeSwiper() {
      const viewportWidth = window.innerWidth;
      const swiperConfig = {
        loop: this.sectionSettings.loop,
        autoplay:
          this.sectionSettings.autoplay_speed === 0
            ? false
            : {
                delay: this.sectionSettings.autoplay_speed * 1000,
                pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
                disableOnInteraction: false,
              },
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: `[data-swiper-id="${this.id}"] .btn-swiper-right`,
          prevEl: `[data-swiper-id="${this.id}"] .btn-swiper-left`,
        },
        pagination: {
          el: `[data-swiper-id="${this.id}"] .swiper-pagination`,
          clickable: true,
        },
        on: {
          slideChange: () => {
            this.slideProgress();
            this.setInfoHeight();
          },
        },
      };

      if (viewportWidth >= 1280) {
        let size = 0;
        if (this.size[2] === "small") {
          size = 576;
        } else if (this.size[2] === "normal") {
          size = 768;
        } else if (this.size[2] === "large") {
          size = 960;
        } else {
          size = 1200;
        }

        Object.assign(swiperConfig, {
          spaceBetween: 32,
          // slidesPerView: viewportWidth / 1200,
          slidesPerView: viewportWidth / size,
          slidesPerGroup: 1,
          centeredSlides: true,
        });
      } else {
        Object.assign(swiperConfig, {
          spaceBetween: 16,
          slidesPerView: 1.14773,
          slidesPerGroup: 1,
          centeredSlides: false,
          autoHeight: true,
          breakpoints: {
            320: {
              width: 320,
              slidesPerView: 1,
              spaceBetween: 16,
            },
            768: {
              width: 628,
              slidesPerView: 1,
              spaceBetween: 16,
            },
          },
        });
      }

      this.mySwiper = new Swiper(`#${this.id} .swiper`, swiperConfig);

      if (
        this.sectionSettings.pause_on_hover &&
        this.sectionSettings.autoplay_speed > 0
      ) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }
      if (this.sectionSettings.autoplay_speed === 0) {
        this.pagination.classList.add("no_autoplay");
      }
    }

    setInfoHeight() {
      const viewportWidth = window.innerWidth;
      this.info = this.querySelectorAll(".text-image-info-box");
      if (viewportWidth >= 1280) {
        let maxHeight = 0;

        this.info.forEach((element) => {
          const elementHeight = element.offsetHeight;
          if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
          }
        });
        this.info.forEach((element) => {
          element.style.height = `${maxHeight}px`;
        });
      }
    }

    slideProgress() {
      if (!this.mySwiper) {
        return;
      }

      if (this.sectionSettings.autoplay_speed === 0) {
        return;
      }

      const bullets = this.pagination.querySelectorAll(
        ".swiper-pagination-bullet"
      );
      const progressDuration = `${
        this.sectionSettings.autoplay_speed * 1000
      }ms`;
      const activeIndex = this.mySwiper.realIndex;

      bullets.forEach((bullet, index) => {
        if (index === activeIndex) {
          bullet.style.setProperty("--progress-duration", progressDuration);
          bullet.style.setProperty("--after-width", "100%");
        } else {
          bullet.style.setProperty("--progress-duration", "0");
          bullet.style.setProperty("--after-width", "0");
        }
      });
    }

    initSlideProgress() {
      const firstBullet = this.pagination.querySelector(
        ".swiper-pagination-bullet"
      );
      if (
        firstBullet &&
        firstBullet.classList.contains("swiper-pagination-bullet-active")
      ) {
        firstBullet.classList.remove("swiper-pagination-bullet-active");
        void firstBullet.offsetWidth;
        firstBullet.classList.add("swiper-pagination-bullet-active");
      }
    }

    autoPlayVideo() {
      const activeSlide = this.querySelector(".swiper-slide-active");
      if (!activeSlide) {
        return;
      }

      const activeVideo = activeSlide.querySelector(
        "video[data-view-autoplay]"
      );
      if (!activeVideo) {
        return;
      }

      const isInViewport = this.isElementInViewport(activeVideo);

      if (isInViewport && !activeVideo.hasAttribute("data-has-played")) {
        activeVideo.play();
        activeVideo.setAttribute("data-has-played", "true"); // Set attribute to mark video as played
      }
    }

    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      const inViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      return inViewport;
    }

    debounce(func, delay) {
      let timer;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    }
  }

  customElements.define("swiper-slide-show", SwiperSlideShow);
}

document.addEventListener("DOMContentLoaded", () => {
  function adjustSwiperWidgetBox() {
    const swiperWidgetBoxes = document.querySelectorAll(".swiper-widget-box");

    if (!swiperWidgetBoxes || swiperWidgetBoxes.length === 0) {
      console.error("No .swiper-widget-box found in the document");
      return;
    }

    swiperWidgetBoxes.forEach((swiperWidgetBox) => {
      if (window.innerWidth >= 1280) {
        const closestTextImageInfoBox = swiperWidgetBox
          .closest(".swiper")
          .querySelector(".swiper-slide-active .text-image-info-box");

        if (closestTextImageInfoBox) {
          const textImageInfoBoxHeight = closestTextImageInfoBox.offsetHeight;
          // swiperWidgetBox.style.height = `${textImageInfoBoxHeight}px`;

          swiperWidgetBox.style.height = `unset`;
          swiperWidgetBox.style.top = `${textImageInfoBoxHeight - 30}px`;

          const textImageInfoBoxRect =
            closestTextImageInfoBox.getBoundingClientRect();
          const rightDistance =
            document.documentElement.clientWidth - textImageInfoBoxRect.right;

          swiperWidgetBox.style.right = `${rightDistance}px`;
        } else {
          console.error("No .text-image-info-box found in the document");
        }
      } else {
        const textImageInfoOuter = swiperWidgetBox
          .closest(".swiper")
          .querySelector(".swiper-slide-active .text-image-info-outer");

        if (textImageInfoOuter) {
          const swiper = swiperWidgetBox.closest(".swiper");
          const textImageInfoOuterRect =
            textImageInfoOuter.getBoundingClientRect();
          const swiperRect = swiper.getBoundingClientRect();
          const topDistance = textImageInfoOuterRect.top - swiperRect.top + 8;

          swiperWidgetBox.style.top = `${topDistance}px`;
        } else {
          console.error("No .text-image-info-outer found in the document");
        }
      }
    });
  }

  adjustSwiperWidgetBox();

  window.addEventListener("resize", adjustSwiperWidgetBox);
});
